import { usePlan } from "@authe/ui-core";

/** Explain the work Free does automatically without presenting configuration. */
export function AutomaticDefaults() {
  const { plan } = usePlan();
  if (plan?.id !== "free") return null;
  return <section className="rounded-xl border bg-muted/20 p-4 text-sm" aria-label="Automatic defaults">
    <h2 className="font-semibold">Ready to explore</h2>
    <p className="mt-1 text-muted-foreground">
      Transactions are decoded automatically with Authe’s standard settings. Confidence checks
      run automatically too, and uncertain results stay clearly marked.
    </p>
    <p className="mt-2 text-muted-foreground">
      Start with a transaction hash or address. No decoder setup, confidence tuning, local network,
      or wallet connection is required.
    </p>
  </section>;
}
